module.exports = __webpack_public_path__ + "img/2a546e8.png";